import { ParallaxBackground } from "@/ui/ParallaxBackground";
import cn from "classnames";
import { Col, Container, Row } from "react-bootstrap";

import useStrategicPartnerships from "@/hooks/useStrategicPartnerships";
import bg_1 from "./bg_1.webp";
import bg_2 from "./bg_2.webp";
import placeholder_img from "./placeholder.png";
import classes from "./styles.module.scss";

export default function ({ className = "py-5", title = "Explore Our Partners", EditableText }) {
  let partners = useStrategicPartnerships();

  const placeholder = {
    title: "Coming Soon",
    logo: placeholder_img,
    className: "placeholder",
  };

  if (partners.length === 1) {
    partners = [...partners, placeholder, placeholder];
  }

  if (partners.length === 2) {
    partners = [...partners, placeholder];
  }

  return (
    <div className={cn(className, classes.FeaturedStrategicPartnerships)}>
      <ParallaxBackground anim="y0:x0:z0" image={bg_1} className={classes.bg_1} floating={false} />
      <ParallaxBackground anim="y1:x1:z1" image={bg_2} className={classes.bg_2} floating={false} />
      <Container className="text-center position-relative z-2" fluid="md">
        <EditableText path="title" tag="h2" className="mb-5">
          {title}
        </EditableText>
        <Row>
          {partners.map(({ title, logo, url_slug, className }) => (
            <Col xs={12} md={4} className="mb-5">
              <a
                href={url_slug ? `/clients/featured-strategic-partnerships/${url_slug}/` : "#"}
                className={cn(className, "partner")}
              >
                <figure>
                  <img src={logo} alt={title} />
                </figure>
                <h3>{title}</h3>
              </a>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}
